import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[480px] md:h-[620px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=A%20beautiful%20artistic%20Korean%20manhwa%20style%20illustration%20background%2C%20soft%20warm%20peach%20and%20cream%20gradient%2C%20delicate%20floating%20cherry%20blossom%20petals%2C%20dreamy%20atmosphere%2C%20abstract%20flowing%20shapes%2C%20gentle%20watercolor%20texture%2C%20elegant%20and%20romantic%20mood%2C%20minimal%20clean%20composition&width=1600&height=720&seq=hero-bg-main&orientation=landscape"
          alt="韩漫屋 - 免费韩漫大全背景"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/15 to-black/35"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6 text-center">
        <h1 className="text-3xl md:text-5xl lg:text-6xl font-bold text-white mb-4 tracking-wide" style={{ fontFamily: 'var(--font-heading)' }}>
          海量免费韩漫，尽在韩漫屋
        </h1>
        <p className="text-base md:text-lg text-white/80 max-w-2xl mx-auto mb-8 leading-relaxed">
          每日更新热门韩国漫画，涵盖恋爱、校园、奇幻、热血等多种题材<br className="hidden sm:block" />
          正版授权，高清画质，为您带来沉浸式的韩漫阅读体验
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
          <Link
            to="/category/romance"
            className="inline-flex items-center gap-2 bg-primary-500 hover:bg-primary-600 text-background-50 px-6 py-3 rounded-full text-sm font-medium transition-all whitespace-nowrap"
          >
            <i className="ri-compass-3-line"></i>
            开始探索
          </Link>
          <Link
            to="/category/fantasy"
            className="inline-flex items-center gap-2 bg-white/15 hover:bg-white/25 text-white backdrop-blur-sm px-6 py-3 rounded-full text-sm font-medium transition-all whitespace-nowrap"
          >
            <i className="ri-fire-line"></i>
            热门推荐
          </Link>
        </div>

        {/* Stats */}
        <div className="flex items-center justify-center gap-8 md:gap-12 mt-10">
          {[
            { value: '2000+', label: '漫画作品' },
            { value: '50万+', label: '活跃读者' },
            { value: '日更', label: '每日更新' },
            { value: '正版', label: '正版授权' },
          ].map((stat) => (
            <div key={stat.label} className="text-center">
              <div className="text-xl md:text-2xl font-bold text-white">{stat.value}</div>
              <div className="text-xs md:text-sm text-white/70 mt-1">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}